import { Auth } from 'aws-amplify';

import {
	AUTHENTICATION_INITIATED,
	AUTHENTICATION_FAILED,
	AUTHENTICATION_SUCCEEDED
} from '../state/actions/AuthenticationActions';


export const authenticateUser = (username, password) => {
  return new Promise(async (resolve, reject) => {
    try {
      await Auth.signIn(username, password);
      resolve(true);
    } catch(e) {
      console.log(e);
    }
		resolve(false);
  });
}



// WEBPACK FOOTER //
// ./services/AuthenticationService.js